import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

if (window.App.pusherKey) {
    window.Pusher = Pusher;

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: window.App.pusherKey,
        cluster: window.App.pusherCluster,
        forceTLS: true,
    });
}
